/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Grid, Dialog, DialogTitle, DialogActions, DialogContent, TextField,
   Checkbox, FormControlLabel,
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import Select from 'react-select';
import api from '../../../service/axios/api';
import Loading from '../../../components/loading/Loading';
import FlashContext from '../../../components/contexts/FlashContext';

const selectStyles = {
  control: provided => ({ ...provided, height: 60, minHeight: 60 }),
  menu: provided => ({ ...provided, zIndex: 9999 }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const typeOptions = [
  { value: 'Fixa', label: 'Fixa' },
  { value: 'Variável', label: 'Variável' },
];

const recurrenceOptions = [
  { value: 'Semanal', label: 'Semanal' },
  { value: 'Quinzenal', label: 'Quinzenal' },
  { value: 'Mensal', label: 'Mensal' },
  { value: 'Semestral', label: 'Semestral' },
  { value: 'Anual', label: 'Anual' },
];

export default function Create({
  openCreate, setOpenCreate, loadingCreate, handleCreate, handleClean,
  supplier, setSupplier, 
  category, setCategory,
  center, setCenter,
  type, setType,
  predictedValue, setPredictedValue,
  nfeNumber, setNfeNumber,
  dateIssue, setDateIssue,
  bankId, setBankId,
  dueDate, setDueDate,
  payingMethod, setPayingMethod,
  obs, setObs,
  isRecurring, setIsRecurring,
  recurrenceType, setRecurrenceType,
  installmentsCount, setInstallmentsCount,
}) {
  const { t } = useTranslation();
  const { notifyError } = useContext(FlashContext);

  const [supplierList, setSupplierList] = useState([]);
  const [centerList, setCenterList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [categoryList, setCategoryList] = useState([]); 

  const getSuppliers = async () => {
    try {
      const { data } = await api.supplier.getAllSelect();
      setSupplierList(data.retorno.map(i => ({ value: i.id, label: i.supplier_name })));
    } catch (error) { notifyError(error.message); }
  };

  const getCenters = async () => {
    try {
      const { data } = await api.costCenter.getAllSelect();
      setCenterList(data.retorno.map(i => ({ value: i.id, label: i.name })));
    } catch (error) { notifyError(error.message); }
  };


  const getCategories = async () => {
    try {
      const { data } = await api.category.getAll([], 999, 1);
      setCategoryList(data.docs.map(i => ({ value: i.id, label: i.name })));
    } catch (error) { notifyError(error.message); }
  };

  const getBanks = async () => {
    try {
      const data = await api.banks.get(false, 'Active');
      setBankList(data.retorno.map(i => ({ value: i.id, label: i.bank })));
    } catch (error) { notifyError(error.message); }
  };

  useEffect(() => {
    getSuppliers();
    getCenters();
    getBanks();
    getCategories(); 
  }, []);

  return (
    <Dialog onClose={() => setOpenCreate(false)} open={openCreate} fullWidth maxWidth="sm">
      <Loading open={loadingCreate} msg={t('billsToPay.createDialog.loading')} />
      <DialogTitle>{t('billsToPay.createDialog.title')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3} style={{ justifyContent: 'center' }}>

          {/* Fornecedor */}
          <Grid item sm={12} xs={12}>
            <Select
              value={supplierList.find(opt => opt.value === supplier) || null}
              placeholder={t('billsToPay.filter.options.supplier')}
              onChange={e => setSupplier(e.value)}
              options={supplierList}
              styles={selectStyles}
              isClearable
            />
          </Grid>

          {/* Centro de Custo */}
          <Grid item sm={12} xs={12}>
            <Select
              value={centerList.find(opt => opt.value === center) || null}
              placeholder={t('billsToPay.filter.options.costCenter')}
              onChange={e => setCenter(e.value)}
              options={centerList}
              styles={selectStyles}
              isClearable
            />
          </Grid>

          {/* Tipo */}
          <Grid item sm={6} xs={12}>
            <Select
              value={typeOptions.find(opt => opt.value === type) || null}
              placeholder="Tipo (Fixa / Variável)"
              onChange={e => setType(e ? e.value : '')}
              options={typeOptions}
              styles={selectStyles}
              isClearable
            />
          </Grid>

          {/* Banco */}
          <Grid item sm={6} xs={12}>
            <Select
              value={bankList.find(opt => opt.value === bankId) || null}
              placeholder="Conta Bancária"
              onChange={e => setBankId(e ? e.value : null)}
              options={bankList}
              styles={selectStyles}
              isClearable
              menuPortalTarget={document.body}
            />
          </Grid>

          {/* Vencimento */}
          <Grid item sm={6} xs={12}>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                label={t('billsToPay.filter.options.dueDate')}
                variant="inline"
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="medium"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={dueDate}
                onChange={date => setDueDate(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          {/* Valor Previsto */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label="Valor Previsto"
              variant="outlined"
              value={predictedValue}
              onChange={e => setPredictedValue(e.target.value)}
              placeholder="0,00"
            />
          </Grid>

          {/* Despesa recorrente */}
          <Grid item sm={12} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isRecurring}
                  onChange={e => setIsRecurring(e.target.checked)}
                  color="primary"
                />
              }
              label="Despesa recorrente (gera várias parcelas automaticamente)"
            />
          </Grid>

          {isRecurring && (
            <>
              {/* Tipo de recorrência */}
              <Grid item sm={6} xs={12}>
                <Select
                  value={
                    recurrenceOptions.find(opt => opt.value === recurrenceType) || null
                  }
                  placeholder="Frequência da recorrência"
                  onChange={e => setRecurrenceType(e ? e.value : '')}
                  options={recurrenceOptions}
                  styles={selectStyles}
                  isClearable
                  menuPortalTarget={document.body}
                />
              </Grid>

              {/* Número de repetições */}
              <Grid item sm={6} xs={12}>
                <TextField
                  fullWidth
                  type="number"
                  label="Número de repetições"
                  variant="outlined"
                  value={installmentsCount}
                  onChange={e => setInstallmentsCount(e.target.value)}
                  inputProps={{ min: 2, max: 360 }}
                  helperText="Quantas vezes essa despesa deve se repetir (incluindo a 1ª parcela)"
                />
              </Grid>
            </>
          )}

          <Grid item sm={6} xs={12}>
            <Select
              value={categoryList.find(opt => opt.value === category) || null}
              placeholder={t('billsToPay.filter.options.category')}
              onChange={e => setCategory(e ? e.value : '')}
              options={categoryList}
              styles={selectStyles}
              isClearable
              menuPortalTarget={document.body}
            />
          </Grid>

          {/* Método de Pagamento */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label={t('billsToPay.filter.options.payingMethod')}
              variant="outlined"
              value={payingMethod}
              onChange={e => setPayingMethod(e.target.value)}
            />
          </Grid>

          {/* Número NFe */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label="Número NFe"
              variant="outlined"
              value={nfeNumber}
              onChange={e => setNfeNumber(e.target.value)}
            />
          </Grid>

          <Grid item sm={6} xs={12}>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                label="Data de Emissão"
                variant="inline"
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="medium"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={dateIssue}
                onChange={date => setDateIssue(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          {/* Observação */}
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              label={t('billsToPay.filter.options.observation')}
              variant="outlined"
              multiline
              value={obs}
              onChange={e => setObs(e.target.value)}
              rows={2}
              maxRows={10}
            />
          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button style={{ height: 40 }} onClick={handleClean} variant="text" color="primary">
          {t('billsToPay.createDialog.buttons.cancel')}
        </Button>
        <Button
          style={{ height: 40 }}
          onClick={handleCreate}
          disabled={loadingCreate}
          variant="contained"
          color="primary"
        >
          {t('billsToPay.createDialog.buttons.create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}